import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ELIGIBILITY_CHECK_SLICE_NAME,
  EligibilityCheckState,
} from './eligibility-check.types';

const initialState = {
  memberBigN: {
    firstName: '',
    lastName: '',
    birthDate: '',
  },
};
export const eligibilityCheckSlice = createSlice({
  name: ELIGIBILITY_CHECK_SLICE_NAME,
  initialState,
  reducers: {
    updateMemberBigN(
      state,
      action: PayloadAction<EligibilityCheckState['memberBigN']>,
    ) {
      state.memberBigN = action.payload;
    },
  },
});

export const reducer = eligibilityCheckSlice.reducer;
export const Actions = eligibilityCheckSlice.actions;
